import type { Chain, VerificationRequest, VerificationResult, ContractFile } from '@/types'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.trustwithintegra.com/v1/verify'
const CHAIN_REGISTRY_URL = 'https://integra-chain-registry-worker.dfisher-3f3.workers.dev/v1'

export async function getChains(): Promise<Chain[]> {
  const response = await fetch(`${CHAIN_REGISTRY_URL}/sourcify/chains`)
  if (!response.ok) {
    throw new Error('Failed to fetch chains')
  }
  return response.json()
}

export async function verifyContract(request: VerificationRequest): Promise<VerificationResult> {
  const formData = new FormData()
  formData.append('address', request.address)
  formData.append('chain', request.chain)

  request.files.forEach((file) => {
    formData.append('files', file)
  })

  const response = await fetch(`${API_BASE_URL}/`, {
    method: 'POST',
    body: formData,
  })

  if (!response.ok) {
    throw new Error('Verification failed')
  }

  return response.json()
}

export async function getVerifiedFiles(chain: string, address: string): Promise<string[]> {
  const response = await fetch(`${API_BASE_URL}/tree/${chain}/${address}`)
  if (!response.ok) {
    if (response.status === 404) {
      return []
    }
    throw new Error('Failed to fetch files')
  }
  return response.json()
}

export async function getFileContents(chain: string, address: string): Promise<ContractFile[]> {
  const response = await fetch(`${API_BASE_URL}/files/${chain}/${address}`)
  if (!response.ok) {
    if (response.status === 404) {
      return []
    }
    throw new Error('Failed to fetch file contents')
  }
  return response.json()
}
